import { Lesson } from '../../../../types';

const lesson: Lesson = {
  itemId: '2084274',
  title: 'Tudo sobre as atualizações',
  video: { platform: 'youtube', videoId: 'wEyhWAfwoco' },
  article: ['Descrição da aula.'],
};
export default lesson;

